<template>
    <a
        :href="this.$root.baseUrl + '/favorites'"
        class="actions-header__item header-favorite"
        :class="{'_active': hasFavorites}"
    >
        <span>{{ totalFavorites || '' }}</span>
    </a>
</template>

<script>
import {mapGetters} from "vuex";
import {countFavorites} from "../../store/modules/favorites/favoritesStorage";

export default {
    name: "FavoritesLink",
    computed: {
        ...mapGetters({
            favoritesIds: 'favorites/favoritesIds'
        }),
        totalFavorites() {
            // Own-estate complexes and properties plus MLS listings.
            return countFavorites(this.favoritesIds);
        },
        hasFavorites() {
            return !!this.totalFavorites;
        }
    }
}
</script>


<style>
    .header-favorite::before {
        content: '';
        position: relative;
        width: 24px;
        height: 24px;
        z-index: 3;
        background: url(/img/header/favorite.svg) center center / contain no-repeat;
    }

    .header-favorite:hover::before,
    .header-favorite._active::before {
        background: url(/img/header/favorite_hover.svg) center center / contain no-repeat;
    }
    @media (any-hover: hover) {
        .header-favorite._active:hover::before {
            opacity: .8;
        }
    }
</style>
